import { TextField, type TextFieldProps } from "@mui/material";
import { type FormikErrors, type FormikTouched } from "formik";

import { type CommitmentPeriod } from "./types";

type Props = TextFieldProps & {
  value?: string;
  errors: FormikErrors<CommitmentPeriod> | string | undefined;
  touched: FormikTouched<CommitmentPeriod> | string | undefined;
  name: string;
};

function isFormikErrors(
  errors: FormikErrors<CommitmentPeriod> | string | undefined
): errors is FormikErrors<CommitmentPeriod> {
  return typeof errors === "object" && errors !== null && !Array.isArray(errors);
}

function isFormikTouched(
  touched: FormikTouched<CommitmentPeriod> | string | undefined
): touched is FormikTouched<CommitmentPeriod> {
  return typeof touched === "object" && touched !== null && !Array.isArray(touched);
}

export const CustomTextField = ({ value, errors, touched, name, ...props }: Props) => {
  const error = isFormikErrors(errors) && isFormikTouched(touched) && !!errors[name] && touched[name];

  return <TextField name={name} value={value} error={error} helperText={error && errors?.[name]} {...props} />;
};
